module.exports = __webpack_public_path__ + "img/2-2.144a597a.svg";